import template from './print_packed_orders.html';
import controller from './print_packed_orders.controller';
import './print_packed_orders.scss';

let printPackedOrdersComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default printPackedOrdersComponent;


// WEBPACK FOOTER //
// ./client/app/components/order_packing/print_packed_orders/print_packed_orders.component.js